import { render, staticRenderFns } from "./ShopListModal.vue?vue&type=template&id=be109f5c"
import script from "./ShopListModal.vue?vue&type=script&lang=js"
export * from "./ShopListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports